import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyState, SectionTitle, Spinner } from "@/components/common";
import { api, fmtDate } from "@/lib/api";

export default function Notifications() {
  const [d, setD] = useState(null);
  const load = () => api.get("/notifications").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);
  const readAll = async () => { await api.post("/notifications/read-all"); load(); };
  if (!d) return <Spinner />;
  return (
    <div className="mx-auto max-w-3xl">
      <SectionTitle title="Notifications" sub={`${d.unread} unread`} right={d.unread > 0 && <Button variant="outline" className="rounded-full" onClick={readAll} data-testid="notifications-read-all">Mark all as read</Button>} />
      {d.items.length === 0 ? <EmptyState icon={Bell} title="You're all caught up" text="Trip updates, RSVPs, itinerary changes and reminders will appear here." /> : (
        <div className="space-y-2" data-testid="notifications-list">
          {d.items.map((n) => (
            <Link key={n.notif_id} to={n.link || "/dashboard"} className={`card card-hover flex items-start gap-3 p-4 ${n.read ? "opacity-70" : ""}`} data-testid={`notification-${n.notif_id}`}>
              <span className={`mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full ${n.read ? "bg-slate-300" : "bg-orange-500"}`} />
              <div><p className="text-sm font-medium">{n.message}</p><p className="text-xs text-slate-500">{fmtDate(n.created_at)}</p></div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
